import { render } from "./TaxAndVatModel.vue?vue&type=template&id=0d545a2c&scoped=true&ts=true"
import script from "./TaxAndVatModel.vue?vue&type=script&lang=ts"
export * from "./TaxAndVatModel.vue?vue&type=script&lang=ts"

import "./TaxAndVatModel.vue?vue&type=style&index=0&id=0d545a2c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d545a2c"]])

export default __exports__